import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CategoryWiseChart = ({ data,chartTitle }) => {
  // Get all unique categories
  const categories = [
    ...new Set(data.flatMap((d) => Object.keys(d).filter((k) => k !== "day")))
  ];

  // Define fixed colors for consistency
  const colors = [
    "#36A2EB", // blue
    "#FFCE56", // yellow
    "#FF6384", // red
    "#4BC0C0", // teal
    "#9966FF", // purple
    "#FF9F40", // orange
    "#8BC34A", // green
  ];

  // Prepare chart data
  const chartData = {
    labels: data.map((d) => moment(d.day).format("D MMM")),
    datasets: categories.map((cat, i) => ({
      label: cat,
      data: data.map((d) => d[cat] || 0),
      backgroundColor: colors[i % colors.length],
    })),
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`;
          },
          footer: function (tooltipItems) {
            let total = 0;
            tooltipItems.forEach((item) => {
              total += item.raw || 0;
            });
            return `Total: ${total}`;
          },
        },
      },
    },
    scales: {
      x: { stacked: true },
      y: {
        stacked: true,
        beginAtZero: true,
        title: { display: true, text: "Count" },
      },
    },
  };

  return (
    <div className="card shadow-sm mb-4 h-full">
      <div className="card-header text-center text-xl font-bold text-gray-700">
        {chartTitle || "Category Wise Chart"}
      </div>
      <div className="card-body" style={{ height: "300px" }}>
        {chartData && chartData.labels && chartData.labels.length > 0 ? (
          <Bar options={options} data={chartData} />
        ) : (
          <p className="text-gray-500 font-semibold flex items-center justify-center h-full">
            No data found for selected criteria
          </p>
        )}
      </div>
    </div>
  );
};

export default CategoryWiseChart;
